export default "__VITE_ASSET__BiD0hqqx__"